import { Button, Form, Input } from "antd";
import { Container } from "../../../../../shared/base-components/Layouts/Container/Container.styles";
import { Flex } from "../../../../../shared/base-components/Layouts/Flex/Flex.styles";
import { Action, Details } from "../TemplateCreate.styles";
import { SheetColumn } from "./Column";
import {
  closestCenter,
  DndContext,
  DragEndEvent,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useState } from "react";
import { restrictToHorizontalAxis } from "@dnd-kit/modifiers";

export interface RuleEngineSheetColumn {
  id: number;
  columnName: string;
  helpText: string;
  columnType: string;
  loopOrder?: number;
  formula?: string;
  columnOrder: number;
}

export const SheetCreate = () => {
  const [data, setData] = useState<RuleEngineSheetColumn[]>([
    {
      id: 1,
      columnName: "Column 1",
      helpText: "Help text for Column 1",
      columnType: "input",
      columnOrder: 1,
    },
    {
      id: 2,
      columnName: "Column 2",
      helpText: "Help text for Column 2",
      columnType: "rowReference",
      loopOrder: 2,
      columnOrder: 2,
    },
    {
      id: 3,
      columnName: "Column 3",
      helpText: "Help text for Column 3",
      columnType: "diagnostics",
      loopOrder: 2,
      formula: "A1 + B2",
      columnOrder: 3,
    },
  ]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 1,
      },
    })
  );

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active.id !== over?.id) {
      setData((prev) => {
        const activeIndex = prev.findIndex((i) => i.id === active.id);
        const overIndex = prev.findIndex((i) => i.id === over?.id);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let activeOrder = prev[activeIndex].columnOrder;
        let orderedData = arrayMove(prev, activeIndex, overIndex);
        orderedData.forEach((data, index) => (data.columnOrder = index + 1));
        return orderedData;
      });
    }
  };

  return (
    <Container>
      <Action>
        <Flex>
          <Form layout="vertical">
            <Form.Item name="name">
              <Input placeholder="Sheet Name" />
            </Form.Item>
          </Form>
          <Button id="add-column" type="primary">Add Column</Button>
        </Flex>
      </Action>
      <Details count={data.length} isHorizontal={true}>
        <Flex alignItems="flex-start" justifyContent="flex-start">
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            modifiers={[restrictToHorizontalAxis]}
            onDragEnd={onDragEnd}
          >
            <SortableContext
              items={data.map((i) => i.id)}
              strategy={horizontalListSortingStrategy}
            >
              {data.map((column) => (
                <SheetColumn key={column.id} column={column} />
              ))}
            </SortableContext>
          </DndContext>
        </Flex>
      </Details>
    </Container>
  );
};
